<template>
  <div class="mt-3">
    <h2 class="fw-bold text-teal">Relatórios</h2>
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/conferir-preenchimento"
          title="Conferir Preenchimento"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Conferir Preenchimento</h5>
              <i class="ph-check-square ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link to="/relatorios/trimestral" title="Trimestral">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Trimestral</h5>
              <i class="ph-calendar ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/trimestral-por-regional"
          title="Trimestral Por Regional"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Trimestral Por Regional</h5>
              <i class="ph-calendar ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link to="/relatorios/receita" title="Receita">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Receita</h5>
              <i class="ph-currency-circle-dollar ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link to="/relatorios/exportacao" title="Exportação">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Exportação</h5>
              <i class="ph-file-csv ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link to="/relatorios/orcamentario" title="Orçamentário">
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Orçamentário</h5>
              <i class="ph-money ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/orcamentario-trimestral"
          title="Orçamentário Trimestral"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Orçamentário Trimestral</h5>
              <i class="ph-money ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/orcamentario-comparativo"
          title="Orçamentário Comparativo"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Orçamentário Comparativo</h5>
              <i class="ph-copy ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/orcamentario-comparativo-ano"
          title="Orçamentário Comparativo Entre Anos"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">
                Orçamentário Comparativo Entre Anos
              </h5>
              <i class="ph-copy ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/memoria-calculo"
          title="Memória de Cálculo"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Memória de Cálculo</h5>
              <i class="ph-brain ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/orcamento-tempo-real"
          title="Orçamento em Tempo Real"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Orçamento em Tempo Real</h5>
              <i class="ph-timer ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/totais-centro-custo"
          title="Totais por Centro de Custo"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Totais por Centro de Custo</h5>
              <i class="ph-calculator ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
      <div v-if="user.isAdmin" class="col-lg-4 col-md-6 mb-3">
        <router-link
          to="/relatorios/importacao-sistego"
          title="Importação SISTEGO"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center py-1"
            >
              <h5 class="text-teal fw-bold mb-0">Importação SISTEGO</h5>
              <i class="ph-file-text ph-2x text-teal"></i>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Relatorios',

  computed: {
    ...mapGetters(['user']),
  },
}
</script>
